import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04d40406"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col last-item custom-drop-down" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'customDropDown',
  props: {
  idPopover: {
    type: String,
    required: true,
  },
  customClass: {
    type: String,
    required: false,
    default: "",
  },
  placement: {
    type: String,
    required: false,
    default: "bottom-start",
  },
  showAcctionClick: { type: Boolean, required: false, default: false },
  showMoreActions: { type: Boolean, required: false, default: false },
  timeout: { type: Number, required: false, default: 1000 },
  offset: { type: Number, required: false, default: 7 },
},
  emits: ["on-hover"],
  setup(__props, { emit }) {

const props = __props;



const hide = ref(9999999999999);
const handleShow = () => {
  emit("on-hover", true);
};

return (_ctx: any,_cache: any) => {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createBlock(_component_b_popover, {
    target: props.idPopover,
    class: "custom-popover !tw-border-0 !tw-fixed",
    triggers: "click blur",
    placement: props.placement,
    "custom-class": 
      __props.customClass
        ? `custom-actions-popover ${__props.customClass}`
        : 'custom-actions-popover'
    ,
    offset: __props.offset,
    delay: {
      show: 0,
      hide: __props.showAcctionClick ? hide.value : __props.timeout,
    },
    onShow: handleShow,
    onHidden: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-hover', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["target", "placement", "custom-class", "offset", "delay"]))
}
}

})